import { useSubscription } from '@apollo/client/react'
import { ProviderAppointmentIntakeDelaysSubscriptionDocument } from '@docpace/manager-graphql/dist/urql.types'
import { ProviderAppointmentIntakeDelaysSubscriptionResultFragment } from '@docpace/manager-graphql'

export function useProviderAppointmentIntakeDelaysSubscription(opts: useSubscription.Options<ProviderAppointmentIntakeDelaysSubscriptionResultFragment>){
    return useSubscription<ProviderAppointmentIntakeDelaysSubscriptionResultFragment>(ProviderAppointmentIntakeDelaysSubscriptionDocument, opts)
}